import {ThunkDispatch} from "@reduxjs/toolkit";
import {useSelector, useDispatch} from 'react-redux'
import LoginHeader from "./LoginHeader"
import {LoadingSpinner} from './Icons'
import {currentUserActions} from '../reducers/currentUser'
import {validateEmail} from '../utils/validation'
import TextInput from "./TextInput";
import CustomButton from "./CustomButton";
import LogoHeader from "./LogoHeader";

const LoginGetResetPassEmail = ({view} : {view: 'company' | 'talent'}) => {
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>()
  const currentUser = useSelector((state: any) => state.currentUser)
  const {isLoading, error, errors} = currentUser

  const resetPassword = (event: any) => {
    event.preventDefault();

    if (isLoading) return
    const formData = new FormData(event.target);
    const email = formData.get('email')
    let errors = {} as any
    const validateEmailRes = validateEmail(email)
    if (validateEmailRes != true)
      errors['email'] = validateEmailRes
    
    dispatch(currentUserActions.setError(null))
    dispatch(currentUserActions.setErrors(errors))
    if (Object.keys(errors).length != 0) return

    dispatch(currentUserActions.resetPassword({email, view}))
  };
  return (
    <div className='static md:fixed md:inset-0 bg-alu-base'>
      <div className='min-w-[24.75rem] static md:absolute md:top-1/2 left-1/2 md:transform md:-translate-x-1/2 md:-translate-y-1/2'>
        <LogoHeader view={view} page="advanced"></LogoHeader>
        <div className='bg-white md:rounded-2xl md:shadow-lg md:max-w-[21.4378rem] md:m-auto md:min-h-max min-h-screen w-full py-0 md:py-6'>
          <LoginHeader title="パスワード再設定"></LoginHeader>
          <div className="flex flex-col items-center justify-center mt-[3.125rem] md:mt-4 px-4 md:px-6">
            <p className='alu-text-base-2 text-sm mb-10'>メールアドレスにパスワード再設定のご案内が送信されます</p>
            <form onSubmit={resetPassword} className="bg-white w-full">
              <div className="mb-10">
                <label className="block mb-2 text-sm pointer-events-none" htmlFor="email">
                  メールアドレス
                </label>
                <div className='relative'>
                  <TextInput
                    error={errors['email'] || error}
                    errorText={errors['email'] || error}
                    id="email"
                    name="email"
                    placeholder="入力してください"
                  />
                </div>
              </div>

              <CustomButton type="submit" disabled={isLoading} width="full">
                <p>{isLoading ? "送信中..." : "送信"}</p>
                {isLoading && (
                  <span><LoadingSpinner /></span>
                )}
              </CustomButton>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginGetResetPassEmail;